import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADMIN_REQUST = 'ADMIN_REQUST';
export const ADMIN_REQUST_SUCCESS = 'ADMIN_REQUST_SUCCESS';
export const ADMIN_REQUST_FAILURE = 'ADMIN_REQUST_FAILURE';

// Action Creators
export const getAdminRequest = () => ({
  type: ADMIN_REQUST,
});

export const getAdminSuccess = (users) => ({
  type: ADMIN_REQUST_SUCCESS,
  payload: users,
});

export const getAdminFailure = (error) => ({
  type: ADMIN_REQUST_FAILURE,
  payload: error,
});

// Thunk Function
export const postAdminRequest = (body, external) => {
  return async (dispatch) => {
    dispatch(getAdminRequest());
    try {
      const response = await postMethodWithToken(url.postRequest, body);
      dispatch(getAdminSuccess(response));
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getAdminSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        external?.handleErrorFunction('error');
      }
    } catch (error) {
      dispatch(getAdminFailure(error?.message));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
